module.exports = __webpack_public_path__ + "static/media/nursing-insurance-card-img.62853e2a.png";